import { HttpClient, HttpHeaders } from '@angular/common/http';
import { Inject, Injectable, InjectionToken, Optional } from '@angular/core';
import { Observable } from 'rxjs';
import { User } from './WOWApi.Service';
export const API_BASE_URL1 = new InjectionToken<string>('API_BASE_URL');
@Injectable({
  providedIn: 'root'
})

export class CustomServiceService {
  private baseUrl: string;
  loggedUser: User; 
  httpOptions: any = {
    headers: new HttpHeaders({
      //'Content-Type': 'application/json'
      "Content-Type": "multipart/form-data"
    })
  };
  constructor(private httpClient: HttpClient, @Optional() @Inject(API_BASE_URL1) baseUrl?: string) {

    this.baseUrl = baseUrl !== undefined && baseUrl !== null ? baseUrl : "";
  }

  UploadWebinarImage(file: any[], webinarId: number): Observable<any> {
    const fm = new FormData();
    console.log(file);
    file.map((item) => {
      if (item.type === 'video') {
        fm.append("fileUploadVideo", item.file);
      }
      if (item.type === 'image') {
        fm.append("fileUploadImage", item.file);
      }
    });
    return this.httpClient.post(this.baseUrl + "/api/Webinar/UploadImageBlob/" + webinarId, fm)
  }

  UploadWebinarImageIphone(file: any[], webinarId: number): Observable<any> {
    const fm = new FormData();
    console.log(file);
    file.map((item) => {
      if (item.type === 'video') {
        fm.append("fileUploadVideo", item.file);
      }
      if (item.type === 'image') {
        fm.append("fileUploadImage", item.file);
      }
    });
    return this.httpClient.post(this.baseUrl + "/api/Webinar/UploadImageBlobIphone/" + webinarId, fm)
  }

  UploadBusinessImage(file: any, requestId: number): Observable<any> {
    const fm = new FormData();
   
      fm.append("fileUpload", file);
     
    return this.httpClient.post(this.baseUrl + "/api/InterestedHost/UploadBusinessImage/" + requestId, fm)
  }

  UploadFFlImage(file: any, requestId: number): Observable<any> {
    const fm = new FormData();
 
      fm.append("fileUpload", file);
    
    return this.httpClient.post(this.baseUrl + "/api/InterestedHost/UploadFFLImage/" + requestId, fm)
  }  

  GetLoggedInUser()
  {
    if(localStorage["UserInfo"] != null)
     {
      this.loggedUser =  JSON.parse(localStorage["UserInfo"])
     }
     else
     {
     this.loggedUser = null;
     }

     return this.loggedUser;
  }

  uploadWebinarAccountSettlementFileUpload(file: any, settlementIds: string): Observable<any> {
    const fm = new FormData();
    fm.append('fileUpload', file);
    return this.httpClient.post(this.baseUrl + `/api/PlatformCharges/UploadSettlementFile/${settlementIds}`, fm)
  }

  UpdateBusinessImageForRoom(file: any, roomId: number, descritpion: string): Observable<any> {
    const fm = new FormData();
    fm.append("fileUpload", file);
    fm.append("description", descritpion);
    return this.httpClient.post(this.baseUrl + "/api/InterestedHost/UpdateBusinessImageForRoom/" + roomId, fm)
  }

  GetRoomBussinessImage(roomId): Observable<string> {
    return this.httpClient.get<string>(this.baseUrl + `/api/HostPortal/RoomBussinessImage/${roomId}`);
  }

  UpdateWebinarUploadedBlobs(file: any[], webinarId: number): Observable<any> {
    const fm = new FormData();
    file.map((item) => {
      if (item.type === 'video') {
        fm.append("fileUploadVideo", item.file);
      }
      if (item.type === 'image') {
        fm.append("fileUploadImage", item.file);
      }
    });
    return this.httpClient.put(this.baseUrl + "/api/Webinar/UpdateWebinarUploadedBlobs/" + webinarId, fm)
  }

  UpdateWebinarUploadedBlobsIphone(file: any[], webinarId: number): Observable<any> {
    const fm = new FormData();
    file.map((item) => {
      if (item.type === 'video') {
        fm.append("fileUploadVideo", item.file);
      }
      if (item.type === 'image') {
        fm.append("fileUploadImage", item.file);
      }
    });
    return this.httpClient.put(this.baseUrl + "/api/Webinar/UpdateWebinarUploadedBlobsIphone/" + webinarId, fm)
  }

  postFacebookImage(file: any, pageId: number, pageAccessToken: string, caption: string): Observable<any> {
    const fm = new FormData();
    fm.append("image", file);
    fm.append("pageId", pageId.toString());
    fm.append("pageAccessToken", pageAccessToken);
    fm.append("caption", caption);
    console.log(fm);
    return this.httpClient.post(this.baseUrl + "/api/Facebook/post-webinar", fm)
  }
}
